import React from "react";
import useAdminStore from "../stores/useAdminStore";
import ProfileView from "./ProfileView";
import ViewAdmin from "./ViewAdmin";

const HomeView = () => {
  const isAdmin = useAdminStore((state) => state.isAdmin);

  return isAdmin ? <ViewAdmin /> : <ProfileView />;
};

export default HomeView;
